import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { get } from "common/helpers/HTTP";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

async function exportConversationRequest(
  workspaceId: string,
  accountId: string,
  conversationUrn: string,
): Promise<string> {
  return (
    await get(
      `workspaces/${workspaceId}/accounts/${accountId}/conversations/${conversationUrn}/export`,
    )
  ).url;
}

export default function useConversationExport() {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const {
    mutateAsync: exportConversation,
    isPending: isExportingConversation,
  } = useMutation({
    mutationFn: ({
      accountId,
      conversationUrn,
    }: {
      accountId: string;
      conversationUrn: string;
    }) => exportConversationRequest(workspaceId, accountId, conversationUrn),
    onSuccess: (url) => {
      toast.success("Conversation exported");
      window.open(url, "_blank");
    },
    onError: () => {
      toast.error("Failed to export conversation, please try again later");
    },
  });

  return { exportConversation, isExportingConversation };
}
